import styled from "styled-components";
import { FaArrowRight } from "react-icons/fa";

export const StyledCard = styled.div`
  background-color: #f4f2f2;
  padding: 0px 15px;
  margin-bottom: 20px;
  margin-top: 5px;
  border-radius: 17px;
  .star {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
  }

  .name {
    font-size: 15px;
    line-height: 18px;
    display: flex;
    font-weight: bold;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-bottom: 17px;
    text-align: center;
    justify-content: center;
  }
  .categoria {
    border: none !important;
    box-sizing: border-box;
    border-radius: 50px;
    font-size: 10px;
    color: #fff;
    padding: 3px 15px;
    font-weight: bold;
    margin-right: 10px;
    margin-bottom: 7px;
  }
  .descripcion {
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    color: #000;
    text-align: center;
    height: 34px;
    max-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .organizacion {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px;
    button {
      border: none;
      background: #003087;
      padding: 7px 20px;
      color: #fff;
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      border-radius: 50px;
      margin-top: 10px;
    }
  }

  .organizacion-compartir {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      border: none;
      background: transparent;
      padding: 7px 30px;
      color: #003087;
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      border: 1px solid #003087;
      border-radius: 50px;
      margin-top: 10px;
    }
  }

  .icono {
    text-align: center;
    img {
      width: 64px;
      height: 64px;
    }
  }

  /*--------- VIEJO ---------*/
  .btn-ir {
    padding-top: 0px !important;
    button {
      border: none;
      background: white;
      padding: 9px 12px;
      font-size: 12px;
      width: 100%;
      text-align: left;
      a {
        color: #000;
        font-size: 12px;
        font-weight: bold;
        display: block;
      }
      svg {
        margin-left: 4px;
      }
    }
    .irlink {
      background: #f72952;
      padding: 5px 10px;
      display: inline-block;
      cursor: pointer;
      a {
        color: white;
      }
    }
  }

  .fecha {
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #000;
    margin-bottom: 0px;
  }
  .line-1 {
    margin-top: 8px;
  }
  .titulo {
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #000;
  }

  .calificacion {
    border: none !important;
    box-sizing: border-box;
    border-radius: 50px;
    font-size: 13px;
    color: #fff;
    padding: 3px 15px;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 10px;
    margin-bottom: 7px;
  }

  .pais-black {
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    font-size: 13px;
    color: #000;
    padding: 3px 15px;
    font-weight: bold;
  }

  .pais-white {
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    font-size: 13px;
    color: #fff;
    padding: 3px 15px;
    font-weight: bold;
  }

  .vacunas {
    background-color: #003087;
    border: 1px solid #003087;
    box-sizing: border-box;
    border-radius: 50px;
    font-size: 13px;
    color: #fff;
    padding: 3px 28px;
    font-weight: bold;
  }

  /* .descripcion {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #000;
  }
  .organizacion {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    button {
      border: none;
      background: #003087;
      padding: 3px 28px;
      color: #fff;
      font-weight: bold;
      font-size: 12px;
      border-radius: 50px;
      margin-left: 10px;
      text-transform: uppercase;
      margin-top: 10px;
    }
  } */
  .card {
    background-color: transparent !important;
    border: none !important;
  }
  .card-header {
    background-color: transparent !important;
    padding-left: 0px !important;
    padding-top: 0px !important;
    border-bottom: none !important;
    cursor: pointer;
    p {
      font-size: 14px;
      margin: 0px;
      display: inline-block;
    }
  }
  .card-body .detalle {
    font-size: 14px;
    span {
      font-weight: bold;
    }
  }
`;
